import { createApiClient, createUploader, type ApiClientOptions } from './client'
import { expireSession, token } from './session'

/**
 * The one client the console talks through. Built from the environment so a
 * preview deployment can point at staging without a rebuild of the code, only
 * of the bundle.
 */
const options: ApiClientOptions = {
  baseUrl: import.meta.env.VITE_API_URL ?? '',
  getToken: () => token.value,
  // A rejected token is dead: drop it here so no later call retries with it.
  // The shell watches the token disappear and sends the user to sign in with
  // a note that the session ended, so a page never sits half-loaded.
  onUnauthorised: expireSession,
}

export const api = createApiClient(options)

/** The same session, for the one upload big enough to want a progress bar. */
export const upload = createUploader(options)

export {
  ApiError,
  type FieldErrors,
  isReadOnlyToken,
  isRefusal,
  isStepUpRequired,
  isNetworkFailure,
  machineCode,
  unwrap,
} from './client'
export { acknowledgeExpiry, clearToken, sessionExpired, setToken, token } from './session'
